import { render } from "./ListNormalPage.vue?vue&type=template&id=348fd15c"
import script from "./ListNormalPage.vue?vue&type=script&lang=js"
export * from "./ListNormalPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__